import { create } from "zustand";

import { push, type Sample } from "../lib/latency";

/**
 * Кольцо замеров задержки команд.
 *
 * ОТДЕЛЬНЫЙ store, а не поле в OrdersState, и это не вкусовщина: OrdersPanel
 * подписан на весь orders-store целиком, и замер, положенный туда, перерисовывал
 * бы таблицу ордеров на каждую команду. Здесь подписчики — только виджеты
 * задержки.
 */
interface LatencyStore {
  samples: Sample[];
  record: (s: Sample) => void;
  clear: () => void;
}

export const useLatency = create<LatencyStore>((set) => ({
  samples: [],
  record: (s) => set((state) => ({ samples: push(state.samples, s) })),
  clear: () => set({ samples: [] }),
}));
